export default "/images/vendor/flag-icon-css/flags/1x1/gn.svg?7bf7a35a82ae814ed25d6219f39db9d3";